












































































































import DatePicker from '@/components/ui/DatePicker.vue'
import { formatarMoeda } from '@/shareds/formatadores'
import { Titulo } from '@/models'
import { BaixaDePagamentoForm } from '@/models/financeiro/BaixaDePagamento'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { CreateBaixaDePagamentoUseCase } from '@/usecases'
import { Vue, Component, Watch, Ref, Prop } from 'vue-property-decorator'
import moment from 'moment-timezone'

@Component({
	components: {
		DatePicker,
	},
})
export default class DialogoDeEdicaoDeBaixasDePagamento extends Vue {
	@Ref() form!: HTMLFormElement
	@Prop({ type: Boolean, default: false }) retornoCrediario!: boolean


	buscando = false
	salvando = false
	mostra = false
	menu2 = false
	time = null
	titulo: Titulo | null = null
	valorFaltante: number | null = null
	formatarMoeda = formatarMoeda

	dataPagamento: string | null = null

	createBaixaDePagamentoUseCase = new CreateBaixaDePagamentoUseCase()

	baixaDePagamento: BaixaDePagamentoForm = {
		titulo: null,
		transactionId: '',
		valorPagamento: 0,
		valorTaxa: 0,
		dataHoraPagamento: '',
		isTaxa: false,
		isIntegracao: false,
	}

	mostrarDialogo(titulo: Titulo | null, valorFaltante: number) {
		this.mostra = true
		this.titulo = titulo ? titulo : null
		this.valorFaltante = valorFaltante
	}

	async salvarBaixa() {
		if (!this.baixaDePagamento) return
		if (!this.titulo) return
		try {
			this.salvando = true
			this.baixaDePagamento.titulo = this.titulo

			if (this.retornoCrediario) {
				this.baixaDePagamento.dataHoraPagamento = new Date().toISOString();
			} else {
				if(!this.dataPagamento){
					return AlertModule.setError('Data de Pagamento é Obrigatória!')
				}
				
				const formattedDateTime = this.gerarDataHora(
					this.dataPagamento,
					this.time,
				);

				this.baixaDePagamento.dataHoraPagamento = formattedDateTime.toString();
			}

			const baixaCriada = await this.createBaixaDePagamentoUseCase.create(this.baixaDePagamento)
			this.$emit('atualizar', baixaCriada)
			this.limparDados()
	
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.salvando = false
			this.mostra = false
		}
	}

	async limparDados() {
		this.baixaDePagamento = {
			titulo: null,
			transactionId: '',
			valorPagamento: 0,
			valorTaxa: 0,
			dataHoraPagamento: '',
			isTaxa: false,
			isIntegracao: false,
		}
		this.time = null
		this.dataPagamento = null
		this.mostra = false
	}

	cancelar() {
		this.limparDados()
	}

	gerarDataHora(data?: string | null, hora?: string | null): string {
		const dateTimeString = `${data}T${hora}:00`;
		const localDateTime = moment(dateTimeString, 'YYYY-MM-DDTHH:mm:ss');
		const utcDateTime = localDateTime.utcOffset(0, true); // Define o offset para 0 (UTC)
		const utcDateTimeString = utcDateTime.toISOString();

		return utcDateTimeString;
	}



	@Watch('mostra')
	onChangeMostra(mostra: boolean) {
		if (!mostra) return

		window.requestAnimationFrame(() => {
			this.form.resetValidation()
		})
	}
}
